<h2 matDialogTitle mat-dialog-draggable-title>
  {{'title.document_download_success' | translate}}
  <button type="button" class="close" aria-label="Close" cdkFocusInitial (click)="close()">
    <span aria-hidden="true">&times;</span>
  </button>
</h2>
<mat-divider></mat-divider>
<mat-dialog-content>
  <div class="row pt-2">
    <div class="col-2 pr-0" style="text-align: center; padding-left: 0px !important; padding-top: 15px">
      <em class="fa fa-check-circle text-success large"></em>
    </div>
    <div class="col-10 pl-0" style="max-height: 35vh; padding-right: 0 !important">
      <p class="message">{{ "document_download.template_from" | translate }}: 
        <span class="font-weight-bold" > {{data.selectedFrom}}</span></p>
      <p class="message">{{ "document_download.template_download_name" | translate }}: 
        <span class="font-weight-bold">{{data.name}}</span>
      </p>
      <p style="margin-bottom: 0 !important;" *ngIf="data.categoryList &&  data.categoryList.length">{{ "document_download.category_list" | translate }}: </p>
      <p style="margin-bottom: 0 !important;" *ngFor="let category of data.categoryList">-&nbsp;{{category.name}}</p>
    </div>
  </div>
</mat-dialog-content>
<mat-divider></mat-divider>
<div mat-dialog-actions class="justify-content-center mt-2">
  <!--build icon, set default cancel-->
  <button mat-stroked-button color="primary" (click)="close()">
    <mat-icon class="mr-0">cancel</mat-icon>
    {{ "document_download.close" | translate }}
  </button>
</div>